<template>
	<div>
		<productCenNav ref="productCenNav" :list="navList" @goScroll="goScroll" v-show="cenNavHidden"></productCenNav>
		<template v-for="(item,index) in navList">
			<component :is="mapComponent[item.value]" :list='item' :ref="item.value" @goScroll='goScroll' />
		</template>
	</div>
</template>

<script>
	import productCenNav from "./productCenNav"
	import mapComponent from "@/components/mapComponentTwo.js";
	export default {
		components: {
			productCenNav,
		},
		data() {
			return {
				mapComponent,
				navList: [
					
				],
				navHidden: false,
				scrollTop: 0,
				scrollTopNav: 0,
				cenNavHidden: true,
				navTop:[],
				querValue:''
			}
		},
		watch: {
			scrollTop() {
				if (this.scrollTop < this.scrollTopNav) {
					this.cenNavHidden = true;
				}
				this.navList.map((v,a)=>{
					if(a+1==this.navList.length){
						if ((this.scrollTop+70) > this.navTop[a]) {
							this.$refs.productCenNav.current=a;
						}
					}else{
						if ((this.scrollTop+70) > this.navTop[a]&&(this.scrollTop+70)< this.navTop[a+1]) {
							this.$refs.productCenNav.current=a;
						}
					}
				})
			},
			querValue(){
				let t=this;
				t.setTop();
			},
			navList(){
				let t=this;
				
				this.$nextTick(function(){
					var element;
					if(this.nowVibe=='pc'){
						element= document.documentElement
					}else{
						element = document.documentElement.scrollTop ? document.documentElement : document.body;
					}
					t.scrollTop = element.scrollTop;
					t.getTop();
				})
			},
			navTop(){
				if (this.scrollTop < this.scrollTopNav) {
					this.cenNavHidden = true;
				}
				this.navList.map((v,a)=>{
					if(a+1==this.navList.length){
						if ((this.scrollTop+70) > this.navTop[a]) {
							this.$refs.productCenNav.current=a;
						}
					}else{
						if ((this.scrollTop+70) > this.navTop[a]&&(this.scrollTop+70)< this.navTop[a+1]) {
							this.$refs.productCenNav.current=a;
						}
					}
				})
			}
		},
		mounted() {
			let t=this;
			let offsetTop = this.$refs.productCenNav.$el.offsetTop;
			this.scrollTopNav = offsetTop;
			window.addEventListener('scroll', this.handleScroll);
			this.querValue=this.$route.query.value;
			t.setList();
			
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll);
		},
		methods: {
			setTop(){
				this.navList.map((v,a)=>{
					if(this.querValue==v.value){
						this.$refs.productCenNav.current=a;
						this.goScroll(this.querValue)
					}
				})
			},
			getTop(){
				let top=[];
				this.navList.map((v,a)=>{
					top.push(this.$refs[v.value][0].$el.offsetTop)
				})
				this.$nextTick(function() {
					this.navTop = top;
				})
				console.log(this.navTop)
			},
			goScroll(e) {
				let offsetTop = this.$refs[e][0].$el.offsetTop - 70;
				this.$emit('goScroll',offsetTop)
				// document.documentElement.scrollTop = offsetTop+10;
			},
			handleScroll(e) {
				this.scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
			},
			setList(){
				let t=this;
				let id = this.$route.query.id;
				let arr=[]
				// 周边产品
				if(Number(id)==1){
					 arr=[
						{
							name: this.$t('i18n_207'),
							value: 'data1',
						},
						{
							name: this.$t('i18n_208'),
							value: 'data2',
						},
						{
							name: this.$t('i18n_209'),
							value: 'data3',
						},
						{
							name: this.$t('i18n_210'),
							value: 'data4',
						},
						{
							name: this.$t('i18n_211'),
							value: 'null',
						},
					];
				};
				if(Number(id)==2){
					 arr=[
						{
							name: this.$t('i18n_212'),
							value: 'data5',
						},
						{
							name: this.$t('i18n_213'),
							value: 'data6',
						},
						{
							name: this.$t('i18n_214'),
							value: 'data7',
						},
					];
				};
				if(Number(id)==3){
					 arr=[
						{
							name: this.$t('i18n_215'),
							value: 'data8',
						},
						{
							name: this.$t('i18n_216'),
							value: 'data9',
						},
						{
							name: this.$t('i18n_217'),
							value: 'data10',
						},
					];
				};
				if(Number(id)==4){
					 arr=[
						{
							name: this.$t('i18n_218'),
							value: 'data11',
						},
						{
							name: this.$t('i18n_219'),
							value: 'data12',
						},
					];
				};
				if(Number(id)==5){
					 arr=[
						{
							name: this.$t('i18n_220'),
							value: 'data13',
						},
						{
							name: this.$t('i18n_221'),
							value: 'data14',
						},
						{
							name: this.$t('i18n_222'),
							value: 'data15',
						},
					];
				};
				// 内镜系统
				if(Number(id)==6){
					 arr=[
						{
							name: this.$t('i18n_223'),
							value: 'data16',
						},
						{
							name: this.$t('i18n_224'),
							value: 'data17',
						},
						{
							name: this.$t('i18n_225'),
							value: 'data18',
						},
						{
							name: this.$t('i18n_226'),
							value: 'data19',
						},
						{
							name: this.$t('i18n_227'),
							value: 'null',
						},
						{
							name: this.$t('i18n_228'),
							value: 'data20',
						},
					];
				};
				if(Number(id)==7){
					 arr=[
						{
							name: this.$t('i18n_229'),
							value: 'data21',
						},
						{
							name: this.$t('i18n_230'),
							value: 'data22',
						},
						{
							name: this.$t('i18n_231'),
							value: 'data23',
						},
						{
							name: this.$t('i18n_232'),
							value: 'data24',
						},
						{
							name: this.$t('i18n_233'),
							value: 'data25',
						},
						{
							name: this.$t('i18n_234'),
							value: 'null',
						},
						{
							name: this.$t('i18n_235'),
							value: 'data26',
						},
					];
				};
				if(Number(id)==8){
					 arr=[
						{
							name: this.$t('i18n_236'),
							value: 'data27',
						},
						{
							name: this.$t('i18n_237'),
							value: 'data28',
						},
						{
							name: this.$t('i18n_238'),
							value: 'data29',
						},
						{
							name: this.$t('i18n_239'),
							value: 'data30',
						},
						{
							name: this.$t('i18n_240'),
							value: 'data31',
						},
						{
							name: this.$t('i18n_241'),
							value: 'data32',
						},
						{
							name: this.$t('i18n_242'),
							value: 'data26',
						},
					];
				};
				if(Number(id)==9){
					 arr=[
						{
							name: this.$t('i18n_243'),
							value: 'data33',
						},
						{
							name: this.$t('i18n_244'),
							value: 'data34',
						},
						{
							name: this.$t('i18n_245'),
							value: 'data35',
						},
						{
							name: this.$t('i18n_246'),
							value: 'data36',
						},
						{
							name: this.$t('i18n_247'),
							value: 'data26',
						},
					];
				};
				if(Number(id)==10){
					 arr=[
						{
							name: this.$t('i18n_248'),
							value: 'data28',
						},
						{
							name: this.$t('i18n_249'),
							value: 'data34',
						},
						{
							name: this.$t('i18n_250'),
							value: 'data35',
						},
						{
							name: this.$t('i18n_251'),
							value: 'data32',
						},
						{
							name: this.$t('i18n_252'),
							value: 'data26',
						},
					];
				};
				if(Number(id)==11){
					 arr=[
						 {
						 	name: this.$t('i18n_253'),
						 	value: 'data28',
						 },
						{
							name: this.$t('i18n_254'),
							value: 'data28',
						},
						{
							name: this.$t('i18n_255'),
							value: 'data34',
						},
						{
							name: this.$t('i18n_256'),
							value: 'data35',
						},
						{
							name: this.$t('i18n_257'),
							value: 'data26',
						},
					];
				};
				
				if(Number(id)==12){
					 arr=[
						 {
						 	name: this.$t('i18n_258'),
						 	value: 'data37',
						 },
						{
							name: this.$t('i18n_259'),
							value: 'data38',
						},
						{
							name: this.$t('i18n_260'),
							value: 'data39',
						},
						{
							name: this.$t('i18n_261'),
							value: 'data40',
						},
						{
							name: this.$t('i18n_262'),
							value: 'data41',
						},
					];
				};
				// 电子内镜
				if(Number(id)==13){
					 arr=[
						 {
						 	name: this.$t('i18n_263'),
						 	value: 'data42',
						 },
						{
							name: this.$t('i18n_264'),
							value: 'data43',
						},
						{
							name: this.$t('i18n_265'),
							value: 'data44',
						},
						{
							name: this.$t('i18n_266'),
							value: 'data45',
						},
						{
							name: this.$t('i18n_267'),
							value: 'data41',
						},
						{
							name: this.$t('i18n_268'),
							value: 'data26',
						},
					];
				};
				if(Number(id)==14){
					 arr=[
						 {
						 	name: this.$t('i18n_269'),
						 	value: 'data46',
						 },
						{
							name: this.$t('i18n_270'),
							value: 'data47',
						},
						{
							name: this.$t('i18n_271'),
							value: 'data48',
						},
						{
							name: this.$t('i18n_272'),
							value: 'data49',
						},
						{
							name: this.$t('i18n_273'),
							value: 'data41',
						},
						{
							name: this.$t('i18n_274'),
							value: 'data26',
						},
					];
				};
				if(Number(id)==15){
					 arr=[
						 {
						 	name: this.$t('i18n_275'),
						 	value: 'data50',
						 },
						{
							name: this.$t('i18n_276'),
							value: 'data51',
						},
						{
							name: this.$t('i18n_277'),
							value: 'data52',
						},
						{
							name: this.$t('i18n_278'),
							value: 'data53',
						},
						{
							name: this.$t('i18n_279'),
							value: 'data54',
						},
						{
							name: this.$t('i18n_280'),
							value: 'data41',
						},
						{
							name: this.$t('i18n_281'),
							value: 'data26',
						},
					];
				};
				if(Number(id)==16){
					 arr=[
						 {
						 	name: this.$t('i18n_282'),
						 	value: 'data55',
						 },
						{
							name: this.$t('i18n_283'),
							value: 'data56',
						},
						{
							name: this.$t('i18n_284'),
							value: 'data57',
						},
						{
							name: this.$t('i18n_285'),
							value: 'data26',
						},
					];
				};
				if(Number(id)==17){
					 arr=[
						 {
						 	name: this.$t('i18n_286'),
						 	value: 'data58',
						 },
						{
							name: this.$t('i18n_287'),
							value: 'data59',
						},
						{
							name: this.$t('i18n_288'),
							value: 'data60',
						},
						{
							name: this.$t('i18n_289'),
							value: 'data61',
						},
						{
							name: this.$t('i18n_290'),
							value: 'data62',
						},
						{
							name: this.$t('i18n_291'),
							value: 'data26',
						},
					];
				};
				if(Number(id)==18){
					 arr=[
						 {
						 	name: this.$t('i18n_292'),
						 	value: 'data63',
						 },
						{
							name: this.$t('i18n_293'),
							value: 'data64',
						},
						{
							name: this.$t('i18n_294'),
							value: 'data65',
						},
						{
							name: this.$t('i18n_295'),
							value: 'data66',
						},
						{
							name: this.$t('i18n_296'),
							value: 'data26',
						},
					];
				};
				if(Number(id)==19){
					 arr=[
						 {
						 	name: this.$t('i18n_297'),
						 	value: 'data67',
						 },
						{
							name: this.$t('i18n_298'),
							value: 'data68',
						},
						{
							name: this.$t('i18n_299'),
							value: 'data69',
						},
						{
							name: this.$t('i18n_300'),
							value: 'data70',
						},
						{
							name: this.$t('i18n_301'),
							value: 'data26',
						},
					];
				};
				if(Number(id)==20){
					 arr=[
						 {
						 	name: this.$t('i18n_302'),
						 	value: 'data71',
						 },
						{
							name: this.$t('i18n_303'),
							value: 'data72',
						},
						{
							name: this.$t('i18n_304'),
							value: 'data73',
						},
						{
							name: this.$t('i18n_305'),
							value: 'data74',
						},
						{
							name: this.$t('i18n_306'),
							value: 'data75',
						},
						{
							name: this.$t('i18n_307'),
							value: 'data26',
						},
					];
				};
				if(Number(id)==21){
					 arr=[
						 {
						 	name: this.$t('i18n_308'),
						 	value: 'data76',
						 },
						{
							name: this.$t('i18n_309'),
							value: 'data77',
						},
						{
							name: this.$t('i18n_310'),
							value: 'data78',
						},
						{
							name: this.$t('i18n_311'),
							value: 'data79',
						},
						{
							name: this.$t('i18n_312'),
							value: 'data80',
						},
						{
							name: this.$t('i18n_313'),
							value: 'data75',
						},
						{
							name: this.$t('i18n_314'),
							value: 'data26',
						},
					];
				};
				if(Number(id)==22){
					 arr=[
						 {
						 	name: this.$t('i18n_315'),
						 	value: 'data81',
						 },
						{
							name: this.$t('i18n_316'),
							value: 'data82',
						},
						{
							name: this.$t('i18n_317'),
							value: 'data83',
						},
						{
							name: this.$t('i18n_318'),
							value: 'data84',
						},
						{
							name: this.$t('i18n_319'),
							value: 'data75',
						},
						{
							name: this.$t('i18n_320'),
							value: 'data26',
						},
					];
				};
				this.navList=arr;
				// this.$nextTick(function(){
				// 	t.scrollTop = document.documentElement.scrollTop;
				// 	t.getTop();
				// })
			}
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">

</style>